import { Box, Stack } from "@mui/material";
import { teamInfo } from "../../utils/avatarUtils";

export const authorMap = {
  FettiQA: 7,
  Fetti: 6,
  Austin: 5,
  Alejandra: 3,
};

const EduAvatar = ({ idx, enlarge = false }) => {
  const { name, title, icon } = teamInfo[idx];
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <img
        src={icon}
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          // transition: "transform 0.2s",
          // ...(enlarge && {
          //   transform: "scale(2.2) rotate(352deg) translate(-3px, -3px)",
          // }),
        }}
      />
      <Stack direction="column" spacing={0}>
        <Box sx={{ fontWeight: "bold" }}>{name}</Box>
        <Box sx={{ color: "#aaa", fontSize: "14px" }}>{title}</Box>
      </Stack>
    </Stack>
  );
};

export default EduAvatar;
